import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    type SubmitGiftVoucherPayGatePaymentMutation,
    type SubmitGiftVoucherPayGatePaymentMutationVariables,
    SubmitGiftVoucherPayGatePaymentDocument,
} from '../../../../../api/mutations/submitGiftVoucherPayGatePayment';
import { type AgreementValues } from '../../../../shared/CIPage/ConsentAndDeclarations/useAgreementsValues';

// calls paygate submit payment api
export const submitPayment = async (agreements: AgreementValues, token: string, promoCodeId?: string) => {
    const response = await fetch('/api/paygate/submitGiftVoucherPayment', {
        method: 'POST',
        body: JSON.stringify({
            token,
            promoCodeId,
            agreedConsents: Object.entries(agreements)
                .filter(Boolean)
                .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null))
                .filter(Boolean),
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error();
    }

    return response.json();
};

// paygate deposit submission calls the application journey
const useGiftVoucherPayGateDepositSubmission = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (token: string, values: AgreementValues, skipDeposit: boolean) => {
            const { data } = await apolloClient.mutate<
                SubmitGiftVoucherPayGatePaymentMutation,
                SubmitGiftVoucherPayGatePaymentMutationVariables
            >({
                mutation: SubmitGiftVoucherPayGatePaymentDocument,
                variables: {
                    token,
                    agreedConsents: Object.entries(values)
                        .filter(Boolean)
                        .map(([consentId, agreementFields]) => (agreementFields.isAgreed ? { id: consentId } : null))
                        .filter(Boolean),
                    skipDeposit,
                },
            });

            return data.result;
        },
        [apolloClient]
    );
};

export default useGiftVoucherPayGateDepositSubmission;
